import moment from "moment-timezone"

export const ascendIsOpen = () => {
  const timeInNY = parseInt(moment.tz("America/New_York").format("H"))
  return timeInNY >= 7 && timeInNY < 19
}
